module.exports = __webpack_public_path__ + "images/3672cbff.gzh-qrcode.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/gzh-qrcode.png
// module id = 360
// module chunks = 0